export class AppConfig {
  //for prod
  // config = {
  //   ipaddress: "https://216.48.183.243",
  // };

  config = {
    ipaddress: "https://erpdev.ibrook.in"
  };
  // kafkaConfig = {
  //   ipaddress: "http://216.48.183.243",
  // };
  kafkaConfig = {
    // ipaddress: "https://164.52.195.172",
    ipaddress: "https://164.52.195.172"
  };

  //for prod
  organizationid = "00CD000000kMAEc";
  userid = "66jD000000qETRx";
  username = "admin@ibrookinfotech.com";
  userlicense = "Sales";
  defaultapplicationid = "w7oD000000h9hak";

  appPageSizeOptions = [10, 25, 50, 100, 200];
  appDefaultPageSize = 25;

  fieldTypes = [
    "autonumber",
    "checkbox",
    "colorpicker",
    "currency",
    "date",
    "time",
    "datetime",
    "double",
    "dropdown",
    "email",
    "id",
    "lookup",
    "mlookup",
    "mlookuptype",
    "map",
    "recordtype",
    "number",
    "picklist",
    "text",
    "textarea",
    "longtext",
    "timestamp",
    "socialmedia",
    "photo",
    "imageupload",
    "fileupload",
    "radio",
    "masterdetail",
    "rollupsummary",
    "richtext",
    "searchtext",
    "daterange",
    "class_section",
    "phone",
    "yearlist",
    "formula",
    "json",
    "pglookup"
  ];
  fieldDataTypes = [
    "autonumber",
    "id",
    "boolean",
    "date",
    "time",
    "datetime",
    "double",
    "dropdown",
    "email",
    "int",
    "json",
    "long text area",
    "lookup",
    "mlookup",
    "mlookuptype",
    "map",
    "number",
    "phone",
    "picklist",
    "string",
    "text",
    "textarea",
    "timestamp",
    "photo",
    "imageupload",
    "fileupload",
    "radio",
    "tel",
    "masterdetail",
    "rollupsummary",
    "richtext",
    "searchtext",
    "daterange",
    "class_section",
    "yearlist",
    "formula",
    "json",
    "pglookup"
  ];

  sortOrderSelect = ["DESC", "ASC"];

  //for field attributes
  /*
fieldAttributes = {
	"id": ["datatype", "length"],
	"text": ["datatype", "length", "regexvalidate", "regex", "rowpertextbox", "quickadd", "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader", "autonumber"],
	"email": ["datatype", "length", "regexvalidate", "regex", "rowpertextbox", "quickadd", "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader"],
	"dropdown": ["datatype", "length", "options", "defaultvalue", "quickadd", "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader"],
	"lookup": ["datatype", "length", {"attr": "relatedto", "type": "string"}, {"attr": "searchapi", "type": "string"}, {"attr": "loadapi", "type": "string"}, {"attr": "idfieldtosave", "type": "string"}, "quickadd", {"attr": "populatedfields", "type": "string"}, "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader", "objectname", "recordtypename", "autocomplete"],
	"picklist": ["datatype", "length", "options", "defaultvalue", "quickadd", "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader", "multiselect"],
	"number": ["datatype", "length", {"attr": "decimal", "type": "number"}, "quickadd", "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader"],
	"boolean": ["datatype", "length", "defaultvalue", "quickadd", "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader"],
	"date": ["datatype", "length", "defaultvalue", "quickadd", "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader"],
	"double": ["datatype", "length", {"attr": "decimal", "type": "number"}, "quickadd", "showinfilter", "showinlist", "showinkanban", "searchable", "titleheader"]
}
*/

  fieldAttributes = {
    id: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "systemfield", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" }
    ],

    text: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "linkfield", type: "string", hint: "12345678" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "regexvalidate", type: "boolean" },
      { attr: "regex", type: "string" },
      { attr: "rowpertextbox", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "firstcolumnsubfields", type: "string" },
      { attr: "mandate", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "concatenate", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    autonumber: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "startingnumber", type: "number" },
      { attr: "displayformat", type: "string" },
      { attr: "sequencename", type: "string" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "firstcolumnsubfields", type: "string" },
      { attr: "mandate", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "concatenate", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    searchtext: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relatedto", type: "list" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "searchablefield", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "regexvalidate", type: "boolean" },
      { attr: "regex", type: "string" },
      { attr: "rowpertextbox", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "mandate", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "concatenate", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    daterange: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relativefromyear", type: "int" },
      { attr: "relativetoyear", type: "int" },
      { attr: "dateonly", type: "boolean" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    colorpicker: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "regexvalidate", type: "boolean" },
      { attr: "regex", type: "string" },
      { attr: "rowpertextbox", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    textarea: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "regexvalidate", type: "boolean" },
      { attr: "regex", type: "string" },
      { attr: "rowpertextbox", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "mandate", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    longtext: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "regexvalidate", type: "boolean" },
      { attr: "regex", type: "string" },
      { attr: "rowpertextbox", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "mandate", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    richtext: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "regexvalidate", type: "boolean" },
      { attr: "regex", type: "string" },
      { attr: "rowpertextbox", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "mandate", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    phone: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "regexvalidate", type: "boolean" },
      { attr: "regex", type: "string" },
      { attr: "rowpertextbox", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "mandate", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "concatenate", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    checkbox: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    email: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "regexvalidate", type: "boolean" },
      { attr: "regex", type: "string" },
      { attr: "rowpertextbox", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    dropdown: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "options", type: "string" },
      { attr: "defaultvalue", type: "string" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    lookup: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relatedto", type: "list" },
      { attr: "childrelationshipname", type: "string" },
      { attr: "relatedlistlabel", type: "string" },
      // { attr: "relationvisibility", type: "string" },
      { attr: "relationvisibility", type: "list" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "iconrelativeurl", type: "string" },
      { attr: "iconname", type: "string" },
      { attr: "searchapi", type: "string" },
      { attr: "loadapi", type: "string" },
      { attr: "idfieldtosave", type: "string" },
      { attr: "objectname", type: "string" },
      { attr: "recordtypename", type: "string" },
      { attr: "populatedfields", type: "string" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "autofillowner", type: "boolean" },
      { attr: "masterdetail", type: "boolean" },
      { attr: "multiselect", type: "boolean" },
      { attr: "maxcount", type: "number" },
      { attr: "controllingfield", type: "string" },
      { attr: "lookupfilterfield", type: "string" },
      { attr: "sortby", type: "list" },
      { attr: "sortorder", type: "list" },
      { attr: "defaulttofirst", type: "boolean" },
      { attr: "islink", type: "boolean" },
      { attr: "preload", type: "boolean" },
      { attr: "parentfield", type: "boolean" },
      { attr: "allownewentity", type: "boolean" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "autocomplete", type: "string" },
      { attr: "firstcolumnsubfields", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    mlookup: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relatedto", type: "list" },
      { attr: "childrelationshipname", type: "string" },
      { attr: "relatedlistlabel", type: "string" },
      { attr: "relationvisibility", type: "string" },
      { attr: "pairfieldname", type: "string" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "iconrelativeurl", type: "string" },
      { attr: "iconname", type: "string" },
      { attr: "searchapi", type: "string" },
      { attr: "loadapi", type: "string" },
      { attr: "idfieldtosave", type: "string" },
      { attr: "objectname", type: "string" },
      { attr: "recordtypename", type: "string" },
      { attr: "populatedfields", type: "string" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "masterdetail", type: "boolean" },
      { attr: "multiselect", type: "boolean" },
      { attr: "islink", type: "boolean" },
      { attr: "preload", type: "boolean" },
      { attr: "parentfield", type: "boolean" },
      { attr: "allownewentity", type: "boolean" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "autocomplete", type: "string" },
      { attr: "firstcolumnsubfields", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    mlookuptype: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "concatenate", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    recordtype: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relatedto", type: "list" },
      { attr: "childrelationshipname", type: "string" },
      { attr: "relatedlistlabel", type: "string" },
      { attr: "relationvisibility", type: "string" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "iconrelativeurl", type: "string" },
      { attr: "iconname", type: "string" },
      { attr: "searchapi", type: "string" },
      { attr: "loadapi", type: "string" },
      { attr: "idfieldtosave", type: "string" },
      { attr: "objectname", type: "string" },
      { attr: "recordtypename", type: "string" },
      { attr: "populatedfields", type: "string" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "masterdetail", type: "boolean" },
      { attr: "multiselect", type: "boolean" },
      { attr: "maxcount", type: "number" },
      { attr: "controllingfield", type: "string" },
      { attr: "lookupfilterfield", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "preload", type: "boolean" },
      { attr: "parentfield", type: "boolean" },
      { attr: "allownewentity", type: "boolean" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "autocomplete", type: "string" },
      { attr: "firstcolumnsubfields", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    class_section: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relatedto", type: "list" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "searchapi", type: "string" },
      { attr: "loadapi", type: "string" },
      { attr: "idfieldtosave", type: "string" },
      { attr: "objectname", type: "string" },
      { attr: "populatedfields", type: "string" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "multiselect", type: "boolean" },
      { attr: "islink", type: "boolean" },
      { attr: "preload", type: "boolean" },
      { attr: "allownewentity", type: "boolean" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "autocomplete", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    masterdetail: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relatedto", type: "list" },
      { attr: "childrelationshipname", type: "string" },
      { attr: "relatedlistlabel", type: "string" },
      { attr: "relationvisibility", type: "string" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "searchapi", type: "string" },
      { attr: "loadapi", type: "string" },
      { attr: "idfieldtosave", type: "string" },
      { attr: "objectname", type: "string" },
      { attr: "recordtypename", type: "string" },
      { attr: "populatedfields", type: "string" },
      { attr: "allownewentity", type: "boolean" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "autocomplete", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    rollupsummary: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "decimal", type: "string" },
      { attr: "relatedto", type: "list" },
      { attr: "summarizedobject", type: "string" },
      { attr: "rolluptype", type: "string" },
      { attr: "fieldtoaggregate", type: "string" },
      { attr: "loadapi", type: "string" },
      { attr: "objectname", type: "string" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "autocomplete", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    map: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relatedto", type: "list" },
      // { attr: "childrelationshipname", type: "string" },
      // { attr: "relatedlistlabel", type: "string" },
      // { attr: "relationvisibility", type: "string" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "searchapi", type: "string" },
      { attr: "loadapi", type: "string" },
      { attr: "idfieldtosave", type: "string" },
      // { attr: "objectname", type: "string" },
      // { attr: "recordtypename", type: "string" },
      // { attr: "populatedfields", type: "string" },
      // { attr: "allownewentity", type: "boolean" },
      // { attr: "quickadd", type: "boolean" },
      // { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      // { attr: "autocomplete", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    photo: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "loadapi", type: "string" },
      { attr: "filter", type: "string" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    imageupload: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "filter", type: "string" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    fileupload: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "filter", type: "string" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    picklist: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "searchapi", type: "string" },
      { attr: "loadapi", type: "string" },
      { attr: "multiselect", type: "boolean" },
      { attr: "maxcount", type: "number" },
      { attr: "controllingfield", type: "string" },
      { attr: "staticdataobject", type: "string" },
      { attr: "mandate", type: "boolean" },
      { attr: "picklisttype", type: "string" },
      { attr: "picklistsource", type: "string" },
      { attr: "options", type: "picklist" },
      { attr: "processfield", type: "boolean" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    number: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "decimal", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    int: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "decimal", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    double: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "decimal", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    boolean: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "defaultvalue", type: "string" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    date: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relativefromyear", type: "number" },
      { attr: "relativetoyear", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    datetime: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relativefromyear", type: "string" },
      { attr: "relativetoyear", type: "string" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    time: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    timestamp: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    socialmedia: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "socialmediatype", type: "string" },
      { attr: "iconname", type: "string" },
      { attr: "linkfield", type: "string" },
      { attr: "linkrelativeurl", type: "string" },
      { attr: "islink", type: "boolean" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    radio: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "groupname", type: "string" },
      { attr: "visiblefields", type: "string" },
      { attr: "hiddenfields", type: "string" },
      { attr: "checkedfields", type: "string" },
      { attr: "searchapi", type: "string" },
      { attr: "multiselect", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],

    yearlist: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "relativefromyear", type: "string" },
      { attr: "relativetoyear", type: "string" },
      { attr: "quickadd", type: "boolean" },
      { attr: "showinfilter", type: "boolean" },
      { attr: "showinlist", type: "boolean" },
      { attr: "showinkanban", type: "boolean" },
      { attr: "searchable", type: "boolean" },
      { attr: "titleheader", type: "boolean" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    formula: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "returntype", type: "list" },
      { attr: "formula", type: "formulatext" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "ignorablefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "uniquefield", type: "boolean" }
    ],
    json: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ],
    pglookup: [
      { attr: "datatype", type: "list" },
      { attr: "length", type: "number" },
      { attr: "expose", type: "boolean" },
      { attr: "autofill", type: "boolean" },
      { attr: "autofillsource", type: "string" },
      { attr: "uniquefield", type: "boolean" },
      { attr: "systemfield", type: "boolean" },
      { attr: "ignorablefield", type: "boolean" }
    ]
  };

  picklistTypes = ["static", "dynamic"];

  picklistSources = ["global", "custom"];

  buttonTypes = ["Common", "DocumentLink", "RowLevel", "Bottom", "Dropdown"];

  buttonActionTypes = [
    "CustomView",
    "MaterialSearch",
    "New",
    "View",
    "QuickCreate"
  ];

  buttonDisplayTypes = ["Button", "Link"];

  buttonBehaviourTypes = ["updatedata", "navigation", "cancel"];

  buttonAttributes = [
    { attr: "displaytype", type: "list" },
    { attr: "behaviourtype", type: "list" },
    { attr: "dropdown", type: "boolean" },
    { attr: "patchfield", type: "string" },
    { attr: "requiredinpatch", type: "string" },
    { attr: "patchtitle", type: "string" },
    { attr: "relatedmodulename", type: "string" },
    { attr: "iconurl", type: "string" },
    { attr: "updateurl", type: "string" },
    { attr: "cloneurl", type: "string" },
    { attr: "returnurl", type: "string" },
    { attr: "relatedurl", type: "string" },
    { attr: "viewrelatedurl", type: "string" },
    { attr: "targeturl", type: "string", hint: "Target URL for this button." },
    { attr: "recordtypeexists", type: "boolean" },
    { attr: "showdialogonclick", type: "boolean" },
    { attr: "activatebutton", type: "boolean" }
  ];

  objectAttributes = [
    {
      attr: "allowrecent",
      label: "Allow Recent",
      type: "boolean",
      hint: "This creates default customviews while creating the object. Applies only in the new mode."
    },
    { attr: "triggers", label: "Triggers", type: "boolean" },
    { attr: "nameconcatenation", label: "Name Concatenation", type: "boolean" },
    { attr: "parentobjects", label: "Parent Objects", type: "string" },
    { attr: "childobjects", label: "Child Objects", type: "string" },
    { attr: "recordsharing", label: "Record Sharing", type: "boolean" },
    { attr: "audittable", label: "Audit Table", type: "boolean" },
    {
      attr: "teaminfo",
      label: "Team Info",
      type: "json",
      hint: "This holds the information about the team."
    },
    { attr: "duplicaterule", label: "Duplicate Rule", type: "boolean" },
    {
      attr: "restrictlookupsharing",
      label: "Restrict Lookup Sharing",
      type: "boolean"
    },
    { attr: "queueEnabled", label: "Queue Enabled", type: "boolean" }
  ];

  operatorTypes = [
    "--None--",
    "equals",
    "not equal to",
    "starts with",
    "contains",
    "does not contain",
    "include",
    "exclude",
    "within",
    "less than",
    "greater than",
    "less or equal",
    "greater or equal"
  ];

  types = ["value", "field"];
  lookupfiltertypes = ["value", "field", "tenantfield"];
  matchingMethodTypes = [
    "equals",
    "exact",
    "fuzzy",
    "greater than",
    "less than",
    "less or equal",
    "greater or equal"
  ];

  defaultLayouts = [
    {
      namesuffix: "New",
      action: "New",
      targeturl: "api/v1/${modulename}/by/id",
      columncount: 2,
      tabkeyorder: "L-R",
      hascustomview: false,
      clonable: false,
      editable: false,
      deletable: false,
      haskanbanview: false,
      active: true,
      attributes: {
        activity: false,
        notesandattachments: false,
        relatedlistflag: false
      }
    },
    {
      namesuffix: "View",
      action: "View",
      targeturl: "api/v1/${modulename}/by/id",
      columncount: 2,
      tabkeyorder: "L-R",
      hascustomview: false,
      clonable: true,
      editable: true,
      deletable: true,
      haskanbanview: false,
      active: true,
      attributes: {
        activity: false,
        notesandattachments: false,
        relatedlistflag: true
      }
    }
  ];

  defaultListviews = [
    {
      namesuffix: "Recently_Viewed",
      viewnameprefix: "Recently_Viewed",
      displaynameprefix: "Recently Viewed",
      filterbyowner: "My",
      publicaccess: true,
      active: true
    },
    {
      namesuffix: "All",
      viewnameprefix: "All",
      displaynameprefix: "All",
      filterbyowner: "All",
      publicaccess: true,
      active: true
    }
  ];
  defaultListviewFields = {
    lead: [
      "id",
      "name",
      "mobilephone1__cf",
      "email",
      "status",
      "leadsource",
      "webreference__cf",
      "age",
      "createddate",
      "ownerid",
      "ownername",
      "ownertype",
      "read"
    ],
    account: [
      "id",
      "name",
      "recordtypename",
      "mobilephone1__cf",
      "phone",
      "billingcity",
      "ownerid",
      "ownername",
      "ownertype",
      "createddate"
    ],
    contact: [
      "id",
      "name",
      "accountname",
      "accountrecordtypename",
      "title",
      "mobilephone1",
      "phone",
      "email",
      "ownerid",
      "ownername",
      "ownertype",
      "createddate"
    ],
    anyothers: [
      "id",
      "name",
      "ownerid",
      "ownername",
      "ownertype",
      "createddate"
    ]
  };

  defaultButtons = {
    lead: [
      "id",
      "name",
      "mobilephone1__cf",
      "email",
      "status",
      "leadsource",
      "webreference__cf",
      "age",
      "createddate",
      "ownerid",
      "ownername",
      "ownertype",
      "read"
    ],
    anyothers: ["Save", "Cancel"]
  };

  COMMON_FIELDS = [
    // {
    //   labelname: "Search",
    //   fieldname: "search",
    //   fieldtype: "searchtext",
    //   standard: true,
    //   primaryfield: false,
    //   required: false,
    //   defaultvalue: "User",
    //   description: "",
    //   active: true,
    //   readonly: false,
    //   visible: true,
    //   id: "10wD00000045vbA",
    //   attributes: {
    //     datatype: "searchtext",
    //     length: "200",
    //     relatedto: "",
    //     searchapi: "",
    //     loadapi: "",
    //     quickadd: false,
    //     showinfilter: true,
    //     showinlist: true,
    //     showinkanban: false,
    //     searchable: false,
    //     titleheader: false,
    //     uniquefield: false,
    //   },
    // },
    //   {"labelname": "Created On", "fieldname": "createdon", "fieldtype": "date", "standard": true, "primaryfield": false, "required": true, "defaultvalue": "", "description": "", "active": true,
    //     "attributes": {"datatype":"date","length":"","quickadd":false,"showinfilter":true,"showinlist":true,"showinkanban":false,"searchable":false,"titleheader":false,"uniquefield":false}
    // },
  ];

  COMMON_BUTTONS = [
    // {"labelname": "Upload", "name": "Upload", "description": "Upload the record", "buttontype": "Common", "actiontype": "New", "active": true,
    //   "attributes": {"recordtypeexists":"","displaytype":"Button","updateurl":"","cloneurl":"","returnurl":"","targeturl":""}
    // },
    // {"labelname": "Save&New", "name": "Save&New", "description": "Save the record and continue adding", "buttontype": "Common", "actiontype": "New", "active": true,
    //   "attributes": {"recordtypeexists":"","displaytype":"Button","updateurl":"api/v1/{{modulename}}/update","cloneurl":"api/v1/{{modulename}}/clone","returnurl":"","targeturl":"api/v1/{{modulename}}/create"}
    // }
  ];
  //leadDefaultListviewFields = ['name','mobilephone1__cf','email','status','leadsource','webreference__cf','age','createddate','ownername','read'];

  //accountDefaultListviewFields = ['name','recordtypename','mobilephone1__cf','phone','billingcity','ownername','createddate'];

  //contactDefaultListviewFields = ['name','accountname','accountrecordtypename','title','mobilephone1','phone','email','ownername','createddate'];
}
